import { useCallback } from 'react';
import { EndPoints } from 'src/config';
import { useFetcher } from 'src/hooks/useFetcher';
import { CatalogAdvisorItem } from '../advisorCatalog.types';

type FetchCatalogPayload = {
  zone: string;
};

export const useAdvisorCatalogLoader = () => {
  const { isLoading, error, data, fetcher } = useFetcher<CatalogAdvisorItem[]>([]);

  const fetchAdvisorCatalog = useCallback(
    (payload: FetchCatalogPayload) => {
      fetcher(EndPoints.getAdvisorCatalog, {
        requiredToken: false,
        body: payload,
      });
    },
    [fetcher],
  );

  return {
    isLoading,
    error,
    data,
    fetchAdvisorCatalog,
  };
};
